import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ProjectPermitTaskServiceCreateResponseJson,
  ProjectPermitTaskServiceListRequestJson,
} from '@vmspdb/definitions';
import { ApiPaginated } from '@vmspdb/ui/domain';

export const PaginatedPermitTaskActions = createActionGroup({
  source: 'PaginatedPermitTask',
  events: {
    Nothing: emptyProps(),
    Cancel: emptyProps(),
    'List PaginatedPermitTasks': props<{
      params: ProjectPermitTaskServiceListRequestJson;
    }>(),
    'List PaginatedPermitTasks Success': props<{
      data: ApiPaginated<ProjectPermitTaskServiceCreateResponseJson>;
    }>(),
    'List PaginatedPermitTasks Failure': props<{ error: unknown }>(),
  },
});
